import React, { useState } from 'react'
import { styles } from './index.sass'
import { Button, message, Card, Modal, Alert, Spin as AntdSpin } from 'antd'
import RichText from '../../components/richText'
import axios from '../../api/axios_ml'
import { cleanHtmlContent } from '../../utils/htmlCleaner'

export const PowerList = () => {
  const [contentHtml, setContentHtml] = useState('')
  const [isEditing, setIsEditing] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleGenerate = async (regenerate = false) => {
    setLoading(true)
    try {
      const payload = regenerate ? { regenerate: true } : {}
      const mockResponseData = await axios.post(
        `${process.env.REACT_APP_ML_API_ENDPOINT}/api/ml/generate-powerlist`,
        payload,
      )

      const cleanedHtml = cleanHtmlContent(
        mockResponseData.content_html.html_content,
      )
      setContentHtml(cleanedHtml)
      message.success('Power List generated successfully!')
    } catch (err) {
      console.error('Error generating Power List:', err)
      message.error(
        err.message || 'Failed to generate Power List. Please try again.',
      )
    } finally {
      setLoading(false)
    }
  }

  const handleSave = (html) => {
    setContentHtml(html)
    setIsEditing(false)
    message.success('Changes saved successfully!')
  }

  const handleCopy = async () => {
    try {
      const cleanedHtml = cleanHtmlContent(contentHtml)

      if (typeof window !== 'undefined' && window.ClipboardItem) {
        const clipboardItem = new window.ClipboardItem({
          'text/html': new Blob([cleanedHtml], { type: 'text/html' }),
          'text/plain': new Blob([cleanedHtml], { type: 'text/plain' })
        })

        await navigator.clipboard.write([clipboardItem])
      } else {
        navigator.clipboard.writeText(cleanedHtml)
      }
      message.success('Copied to clipboard')
    } catch (err) {
      const cleanedHtml = cleanHtmlContent(contentHtml)
      navigator.clipboard.writeText(cleanedHtml)
      message.success('Copied to clipboard')
    }
  }

  const handleRegenerate = () => {
    Modal.confirm({
      title: 'Regenerate Power List',
      content: 'This will replace the current content. Continue?',
      onOk: () => handleGenerate(true)
    })
  }

  return (
    <div className={styles}>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-popup">
            <AntdSpin size="large" style={{ marginBottom: '16px' }} />
            <div className="loading-text">Generating content</div>
            <div className="loading-subtext">
              This will take less than 3 minutes. Please wait...
            </div>
          </div>
        </div>
      )}
      <div className="container">
        <h2>Power List Content Generator</h2>
        <div className="actions">
          <Button type="primary" onClick={handleGenerate} loading={loading}>
            Generate Power List
          </Button>
          <Button onClick={handleRegenerate} disabled={!contentHtml || loading}>
            Regenerate
          </Button>
          <Button onClick={handleCopy} disabled={!contentHtml}>
            Copy Content
          </Button>
        </div>
        {contentHtml && (
          <Card className="content-card">
            {isEditing ? (
              <RichText
                value={contentHtml}
                onChange={handleSave}
                placeholder="Edit your Power List content here..."
              />
            ) : (
              <>
                <div
                  className="content-preview"
                  dangerouslySetInnerHTML={{ __html: contentHtml }}
                />
              </>
            )}
          </Card>
        )}
      </div>
    </div>
  )
}
